import React from "react";
import styled from "styled-components";
import StartupButton from "./StartupButton";
import NavLinks from "./NavLinks";
import MicrosoftSignInButton from "./MicrosoftSignInButton";
import SidebarAction from "./SidebarAction";


const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  position: sticky !important;
  top: 70px;
`;

const Sidebar = ({ startupDetails, navLinks }) => {
  
  return (
    <SidebarContainer>
      <MicrosoftSignInButton onClick={null} />
      <StartupButton
        startupName={startupDetails.startupName}
        subText={startupDetails.subText}
        startupImage={startupDetails.startupImage}
      />
      <div>
        <NavLinks links={navLinks} />
      </div>
      <SidebarAction sidebar={true} />
    </SidebarContainer>
  );
};

export default Sidebar;
